import React from 'react'
import {
	IconButton,
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
} from '@chakra-ui/react'
import Link from 'next/link'
import { HamburgerIcon } from '@chakra-ui/icons'
import posthog from 'posthog-js'
import tenantData from '@crosure/tenant/data'
import type { SiteNavLink } from '@/lib/siteNavigation'

/** `items` is the Studio-merged `nav_primary` from `loadSiteNavigation()`.
 *  Falls back to the bundle's nav when the caller hasn't passed it yet. */
export const MenuLanding = ({ items }: { items?: SiteNavLink[] }) => {
	const bundleItems =
		(tenantData as any)?.landing?.navigation?.primary?.items ?? []
	const navItems = items ?? bundleItems

	const handlePosthogClick = ({
		posthogEvent,
	}: {
		posthogEvent: string | undefined
	}) => {
		if (posthogEvent) {
			posthog.capture(posthogEvent)
		}
	}
	return (
		<Menu>
			<MenuButton
				as={IconButton}
				size={{ base: 'sm', md: 'md' }}
				borderRadius='full'
				variant='subtle'
				aspectRatio={1}
				aria-label='Menu'
				icon={<HamburgerIcon />}
			/>
			<MenuList>
				{navItems.map(item => (
					<MenuItem
						key={item.label}
						as={Link}
						href={item.href}
						fontWeight='semibold'
						onClick={() =>
							handlePosthogClick({ posthogEvent: item.posthogEvent })
						}
						color='primary.600'
					>
						{item.label}
					</MenuItem>
				))}
			</MenuList>
		</Menu>
	)
}
